import { render } from "./Cliente.vue?vue&type=template&id=fc1b9b3a&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./Cliente.vue?vue&type=script&lang=js"
export * from "./Cliente.vue?vue&type=script&lang=js"

import "./Cliente.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script